import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import lodashGet from 'lodash/fp/get';
import { withRouter } from 'react-router';

import {
  numberWithCommas,
  squareFeetDisplayString,
} from 'common/formatters';

import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';
import SrSearchItem from 'client/components/SrSearchItem';

import filterListItems from 'client/helpers/filterListItems';

@withRouter
class SrSearchFilterList extends Component {
  static propTypes = {
    listingsViewMode: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    redirectTo: PropTypes.string.isRequired,
    resultsCount: PropTypes.number,
    resultsCountIsLoading: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
  }

  render() {
    const {
      listingsViewMode,
      filters,
      redirectTo,
      onSubmit,
      onChange,
      resultsCount,
      resultsCountIsLoading,
      history,
      market,
    } = this.props;

    const disabledSearchFilters = (market.settings.searchFilters || {}).disabled || [];

    return (
      <div>
        <span className='headline'>Search Filters</span>
        <div className='section'>
          <div
            className='row twoColumns'
            onClick={() => {
              history.push('/search/rentPriceRange');
            }}
          >
            <span className='title'>Price Range</span>
            <span className='value'>
              {typeof filters.minRentPrice === 'number' ? `$${numberWithCommas(filters.minRentPrice)}` : '--'}
              {' - '}
              {filters.maxRentPrice ? `$${numberWithCommas(filters.maxRentPrice)}` : '--'}
            </span>
          </div>
          <SrSearchItem
            {...filterListItems.area}
            value={listingsViewMode === 'map' ? 'Based on map position' : market.displayName}
            isDisable={listingsViewMode === 'map'}
            redirectTo={redirectTo}
          />
          <SrSearchItem
            {...filterListItems.propertyTypes}
            value={lodashGet('propertyTypes', filters)}
            redirectTo={redirectTo}
          />
          <SrSearchItem
            {...filterListItems.moveInDate}
            value={lodashGet('moveInDate', filters)}
            redirectTo={redirectTo}
          />
          <SrSearchItem
            {...filterListItems.bedrooms}
            onChange={onChange}
            value={lodashGet('bedrooms', filters) || []}
            redirectTo={redirectTo}
          />
          <SrSearchItem
            {...filterListItems.bathrooms}
            onChange={onChange}
            value={lodashGet('bathrooms', filters) || 0}
            redirectTo={redirectTo}
          />
          {!disabledSearchFilters.includes('pets') && (
            <SrSearchItem
              {...filterListItems.pets}
              onChange={onChange}
              value={lodashGet('pets', filters) || []}
              redirectTo={redirectTo}
            />
          )}
          <div
            className='row twoColumns squareFeet'
            onClick={() => {
              history.push('/search/squareFeet');
            }}
          >
            <span className='title'>Square Feet</span>
            <span className='value'>
              {squareFeetDisplayString({
                minSquareFeet: filters.minSquareFeet,
                maxSquareFeet: filters.maxSquareFeet,
              })}
            </span>
          </div>
          <SrSearchItem
            {...filterListItems.unitAmenities}
            value={lodashGet('unitAmenities', filters) || []}
            redirectTo={redirectTo}
          />
          <SrSearchItem
            {...filterListItems.section8}
            onChange={onChange}
            value={lodashGet('section8', filters)}
            redirectTo={redirectTo}
          />
        </div>
        <div className='saveFilterContainer'>
          <ButtonDeprecated
            onClick={onSubmit}
            theme={BUTTON_THEME_BLUE}
            disabled={resultsCountIsLoading}
          >
            {resultsCountIsLoading
              ? 'please wait...'
              : (typeof resultsCount === 'number'
                ? `save (${resultsCount} ${pluralize('match', resultsCount)})`
                : 'save filter'
              )
            }
          </ButtonDeprecated>
        </div>
      </div>
    );
  }
}

SrSearchFilterList.displayName = 'SrSearchFilterList';

export default SrSearchFilterList;
